import { DatePipe, Time } from '@angular/common';
import { Component, OnInit, Input } from '@angular/core';
import { SharedService } from 'src/app/shared.service'
import swal from 'sweetalert';

@Component({
  selector: 'app-add-edit-attendance',
  templateUrl: './add-edit-attendance.component.html',
  styleUrls: ['./add-edit-attendance.component.scss']
})
export class AddEditAttendanceComponent implements OnInit {

  constructor(private service: SharedService) { }

  @Input() attend:any;
  @Input() empId!: number;
  pkAttendanceId!: number;
  fkEmpId!:number;
  Arrival!: string;
  Departure!: string;
  Date!: string;
  DurationOfTasks!: number;


  ngOnInit(): void
  {
    this.pkAttendanceId = this.attend.pkAttendanceId;
    this.fkEmpId = this.attend.fkEmpId;
    this.Arrival = this.attend.Arrival;
    this.Departure = this.attend.Departure;
    this.Date = this.attend.Date;
    this.DurationOfTasks = this.attend.DurationOfTasks;
  }


  Test()
  {
    console.log(this.attend);
    console.log(this.Date);
    console.log(this.Departure);
    console.log(this.Arrival);
    console.log(this.empId);
  }


  AddAttendance()
  {
    var val =
    {
      fkEmpId: this.empId,
      Arrival: this.Arrival,
      Departure: this.Departure,
      Date: this.Date
    };
    this.service.AddAttendance(val).subscribe(res =>
      {
        swal(res.toString(), '', "info")
      });
  }

  UpdateAttendance()
  {
    var val =
    {
      pkAttendanceId: this.pkAttendanceId,
      fkEmpId: this.fkEmpId,
      Arrival: this.Arrival,
      Departure: this.Departure,
      Date: this.Date,
      DurationOfTasks: this.DurationOfTasks
    };
    this.service.UpdateAttendance(val).subscribe(res =>
      {
        swal(res.toString(), '', "info")
      });
  }
}
